import { useMemo } from "react";
import useCapabilities from "@/hooks/useCapabilities";
import useEffectiveDisplayUser from "@/hooks/useEffectiveDisplayUser";

export type CurrentBackofficeUser = {
  id: string;
  name: string;
  email: string;
  department?: string | null;
};

export default function useCurrentBackofficeUser(): CurrentBackofficeUser | undefined {
  const user = useEffectiveDisplayUser();
  const { id: currentUserId } = useCapabilities();

  return useMemo(() => {
    if (!currentUserId || !user?.name) return undefined;
    return {
      id: currentUserId,
      name: user.name,
      email: user.email,
      department: user.department
    };
  }, [currentUserId, user?.name, user?.email, user?.department]);
}
